import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class SefrakMinne extends Component {
    state = {
        isOpened: false
    }

    toggleSefrakMinne = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var sefrakMinne = this.props.sefrakminne
        
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleSefrakMinne}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{sefrakMinne.objektnavn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('objektnavn')}</div>
                            <div className="value">{sefrakMinne.objektnavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('lokaltnavn')}</div>
                            <div className="value">{sefrakMinne.lokaltnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('verdivurdering')}</div>
                            <div className="value">{sefrakMinne.verdivurdering}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('etasjetall')}</div>
                            <div className="value">{sefrakMinne.etasjetall}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bredde')}</div>
                            <div className="value">{sefrakMinne.bredde}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('lengde')}</div>
                            <div className="value">{sefrakMinne.lengde}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('byggetid')}</div>
                            <div className="value">{sefrakMinne.byggeTid}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('revetbrenttid')}</div>
                            <div className="value">{sefrakMinne.revetBrentTid}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('vernevedtak')}</div>
                            <div className="value">{sefrakMinne.vernevedtak}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('fredning')}</div>
                            <div className="value">{sefrakMinne.fredning}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('feltregistrertav')}</div>
                            <div className="value">{sefrakMinne.feltregistrertAv}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('feltregistrertdato')}</div>
                            <div className="value"><Moment local>{sefrakMinne.feltregistrertDato}</Moment></div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(SefrakMinne)